import { createMemo } from "solid-js"
import { type DirectionDxDy } from "src/lib/core/direction/DirectionDxDy.type"
import eightDirections from "../../lib/core/direction/eightDirections"
import createSharedCachedFactory from "./createSharedCachedFactory"
import useGridWidthHeight from "./useGridWidthHeight"

export const useNodeNeighborIndexMap = createSharedCachedFactory((engine) => {
  const getGridSize = useGridWidthHeight(engine)

  const getNodeNeighborIndexMap = createMemo(() => {
    // console.log('getNodeNeighborIndexMap.memo', engine.id)
    const { width, height } = getGridSize()
    const neighborMap = new Map<DirectionDxDy, Int16Array>()

    // Pre-calculate neighbor indices for each direction
    for (const direction of eightDirections) {
      const directionIndexes = new Int16Array(width * height)
      directionIndexes.fill(-1) // -1 means no neighbor

      const { dx, dy } = direction

      // Calculate all neighbor indices for this direction
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const centerIndex = x + (y * width)

          const neighborX = x + dx
          const neighborY = y + dy

          // Bounds check
          if (neighborX >= 0 && neighborX < width && neighborY >= 0 && neighborY < height) {
            const neighborIndex = neighborX + (neighborY * width)
            directionIndexes[centerIndex] = neighborIndex
          }
        }
      }

      neighborMap.set(direction, directionIndexes)
    }
    return neighborMap
  })

  return getNodeNeighborIndexMap
})